import React, { useState, useRef } from 'react';
import { Select, Popover } from 'antd';
import { useQuerySearcher } from '../../../hooks/searcher/useQuerySearcher';
import { Spinner } from 'react-bootstrap';
import { useEffect } from 'react';
import SelectArrow from '../../Common/SelectArrow/SelectArrow';
import iconInformation from '../../../imgs/icon-i.png';
import { useSearchFilterTableContext } from '../../../context/SearchFilterTableContext';
import { useSearchParams, useSearchParamsDispatch } from '../../../context/SearchParamsContext';


import './SearchBox.css';
import { useExportFiles } from '../../../hooks/main/useExportFiles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const fondosInversion = [
    {
        value: 'fondos',
        label: 'Fondos de inversión'
    },
    {
        value: 'planesindiv',
        label: 'Planes de pensiones'
    },
    {
        value: 'epvs',
        label: 'EPSVS'
    },
    {
        value: 'planesasoc',
        label: 'Planes asociados'
    },
    // {
    //     value: 'planosEmpleo',
    //     label: 'Planos de empleo'
    // }
];

const categorías = [
    {value: '3', label: 'Renta Fija'},
    {value: '2', label: 'Mixtos y globales'},
    {value: '1', label: 'Renta Variable'},
    {value: '4', label: 'Otros'}
];

const nivelRiesgo = [
    { value: '1', label:'1'},
    { value: '2', label:'2'},
    { value: '3', label:'3'},
    { value: '4', label:'4'},
    { value: '5', label:'5'},
    { value: '6', label:'6'},
    { value: '7', label:'7'},
]

const geografías = [
    {value: 'AREAS0', label: 'España'},
    {value: 'AREAS1', label: 'Europa'},
    {value: 'AREAS2', label: 'Global'},
    {value: 'AREAS3', label: 'Emergentes'}
];

const horizontes = [
    {value: '01', label: 'Corto Plazo'},
    {value: '02', label: 'Medio Plazo'},
    {value: '03', label: 'Largo Plazo'}
];

const divisas = [
    {value: 'EUR', label: 'EUR'},
    {value: 'USD', label: 'USD'}
];

const inversionMinima = [
    {value: '30', label: '30 €'},
    {value: '100', label: '100 €'},
    {value: '500', label: '500 €'},
    {value: '1000', label: '1.000 €'},
    {value: '6000', label: '6.000 €'},
    {value: '20000', label: '20.000 €'},
    {value: '60000', label: '60.000 €'},
    {value: '100000', label: '100.000 €'},
    {value: '300000', label: '300.000 €'},
    {value: '1000000', label: '1.000.000 €'},
    {value: '5000000', label: '5.000.000 €'},
    {value: '10000000', label: '10.000.000 €'},
    {value: '100000000', label: '100.000.000 €'}
]

const SearchBox = ({onHandleFilter}) => {
    const mountCounter = useRef(0);
    const [showMoreFilters, setShowMoreFilters] = useState(false);
    const searchRef = useRef('');
    const searchParamsState = useSearchParams();
    const searchParamsDispatch = useSearchParamsDispatch();
    const { queryFilters, loading, searchResults, querySearch } = searchParamsState;

    //Esto habría que pasarlo a hook para testearlo
    // const handleData = (e) => {
    //     //e.preventDefault()
    //     let stringPetition = '';

    //     //Parse each input into the string
    //     const search = searchRef.current.value;m
    //     if(search !== '') stringPetition += ('fundsname=' + search);

    //     // TODO Faltan el resto de datos, cuando Jaime me de el resto del JSON lo completo
    //     //if(searchOptions.fondos !== 'fondos')

    //     //We send it to the main component (App.js)
    //     searchData(stringPetition);
    // };

    /*const getRiesgoColor = () => {
        return searchOptions.riesgo > 5 ? 'red' : searchOptions.riesgo > 3 ? 'orange' : 'green'
    }*/

    /*const toggleSelectionArray = (selection, array, event) => {
        console.info("toggleSelectionArray" + selection)
        event.preventDefault();
        switch(array){
            case 'descri_categoria':
                let aux = [...searchOptions.descri_categoria];
                const index = aux.indexOf(selection);
                if(index > -1){
                    aux.splice(index, 1);
                }else{
                    aux.push(selection);
                }
                setSearchOptions({...searchOptions, descri_categoria: aux})
                break;
            case 'geografia':
                let aux2 = [...searchOptions.geografia];
                const index2 = aux2.indexOf(selection);
                if(index2 > -1){
                    aux2.splice(index2, 1);
                }else{
                    aux2.push(selection);
                }
                setSearchOptions({...searchOptions, geografia: aux2})
                break;
            case 'horizonte':
                let aux3 = [...searchOptions.horizonte];
                const index3 = aux3.indexOf(selection);
                if(index3 > -1){
                    aux3.splice(index3, 1);
                }else{
                    aux3.push(selection);
                }
                setSearchOptions({...searchOptions, horizonte: aux3})
                break;
            case 'divisa':
                let aux4 = [...searchOptions.divisa];
                const index4 = aux4.indexOf(selection);
                if(index4 > -1){
                    aux4.splice(index4, 1);
                }else{
                    aux4.push(selection);
                }
                setSearchOptions({...searchOptions, divisa: aux4})
                break;
            default:
                break;
        }
    }*/

    // console.info("VALUE SEARCHER", searchOptions);

    /***** Lógica para realizar petición de búsqueda ******/

    
    // const [filterSearcher, setfilterSearcher] = useState({
        //     tipoFondo: '',
        //     categoria: '',
        //     nivelRiesgo: '',
        //     geografia: '',
        //     horizonte: '',
        //     divisa: '',
        //     inversionMinima: '',
        // });
        
        // const handleFiltroChange = (filterName, value) => {
            //     setfilterSearcher((prevFiltros) => ({
                //       ...prevFiltros,
                //       [filterName]: value,
                //     }));
                //   };
    const {setTableData} = useSearchFilterTableContext();
    const { handleSearch } = useQuerySearcher();
    // const { setQuerySearchExport, setQueryFiltersExport, queryFiltersExport } = useExportFiles();
    const { setQuerySearchExport, setQueryFiltersExport } = useExportFiles();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const handleSearchSubmit = async(event) => {
        setTableData([]);
        searchParamsDispatch({ searchResults: [] });
        event?.preventDefault();
        await handleSearch();
        onHandleFilter({...queryFilters,querySearch});
        setQueryFiltersExport(queryFilters);
    };
    const clickEvento = (letra) => {
        let event1 = {
            "event": "en_click",
            "ep_view_name": "Buscador",
            "ep_user_id": "",
            "ep_user_type": "",
            "ep_action_detail": letra, 
            "ep_element_type": "button",
            "ep_destination_url": "" 
        };
    
        (window.dataLayer = window.dataLayer || []).push(event1);
    }
    const clickEventoMas = (letra) => {
       let boton = "Mostrar mas filtros";
       if(letra){
           boton = "Mostrar menos filtros"
       }
        let event1 = {
            "event": "en_click",
            "ep_view_name": "Buscador",
            "ep_user_id": "",
            "ep_user_type": "",
            "ep_action_detail": boton, 
            "ep_element_type": "button",
            "ep_destination_url": "" 
            };
    
          (window.dataLayer = window.dataLayer || []).push(event1);
    }
    const anadirFiltro = (event) => {
        //const keys = Object.keys(event);
        const val = Object.values(event);
        let event1 = {
            "event": "en_search",
            "ep_view_name": "Buscador",
            "ep_user_id": "",
            "ep_user_type": "",
            "ep_action_detail": "Anadir filtro", 
            "ep_keyword": "",
            "ep_filter_type": "Producto" ,
            "ep_filter_selection": val[0]  
            };
    
          (window.dataLayer = window.dataLayer || []).push(event1);
    }
    
    const eliminarFiltro = (event) => {
        let event1 = {
            "event": "en_search",
            "ep_view_name": "Buscador",
            "ep_user_id": "",
            "ep_user_type": "",
            "ep_action_detail": "Eliminar filtro", 
            "ep_keyword": "",
            "ep_filter_type": "Producto",
            "ep_filter_selection": ""
            };
    
          (window.dataLayer = window.dataLayer || []).push(event1);
    }

    useEffect(() => {
        if (mountCounter.current > 0) return;

        (async () => {
            mountCounter.current = 1;
            await handleSearch();
        })();

        return () => {
            // This now gets called when the component unmounts
        };
    }, [handleSearch]);
    
    useEffect(() => {
        setTableData(searchResults);
    }, [searchResults, setTableData]);

    const [cleanFilters, setCleanFilters] = useState(false);

    useEffect(() => {
        if(cleanFilters) {
            handleSearchSubmit();
            setCleanFilters(false);
        };
    }, [cleanFilters, handleSearchSubmit]);

    const handleCleanFilters = () => {
        searchParamsDispatch({
            queryFilters: {},
            querySearch: "",
            validationDate: null,
        });
        setQuerySearchExport('');
        searchRef.current.value = '';
        clickEvento("Limpiar filtros");
        setCleanFilters(true);
    };

    return (
        <section className='search-box'>
            <h1 className='sub-title'>Bienvenid@ ¿Qué le interesa buscar?</h1>
            <div className='d-flex flex-row justify-content-center container-search' style={{width: '100%'}}>
                <form className='flex-fill' onSubmit={handleSearchSubmit} style={{maxWidth: 1170}}>
                    {/* Input buscador principal */}
                    <div style={{display: 'flex', justifyContent: 'space-between'}}>
                        <span style={{fontSize: '12px', fontWeight: 500}}>Seleccione búsqueda</span>
                        <span
                            onClick={handleCleanFilters}
                            style={{fontSize: '14px', fontWeight: 500, color: 'red', cursor: 'pointer'}}>
                                Limpiar filtros
                        </span>
                    </div>
                    <div className='search-content search-center-dropdown main-search'>
                        <div className='flex-fill'>
                            <input onChange={(e) => searchParamsDispatch({querySearch: e.target.value})} style={{fontSize: '1rem', border: '0px', background: 'transparent'}} ref={searchRef} type='text' className='form-control shadow-none' placeholder='Pulse en la imagen o indique el producto que desee buscar'/>
                        </div>
                        <button className='spyglassSearch' onClick={handleSearchSubmit}>
                            {/*<i className="fa-solid fa-magnifying-glass"></i>*/}
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M480 272C480 317.9 465.1 360.3 440 394.7L566.6 521.4C579.1 533.9 579.1 554.2 566.6 566.7C554.1 579.2 533.8 579.2 521.3 566.7L394.7 440C360.3 465.1 317.9 480 272 480C157.1 480 64 386.9 64 272C64 157.1 157.1 64 272 64C386.9 64 480 157.1 480 272zM272 416C351.5 416 416 351.5 416 272C416 192.5 351.5 128 272 128C192.5 128 128 192.5 128 272C128 351.5 192.5 416 272 416z"/></svg>
                        </button>
                    </div>
                    <div style={{position: 'relative'}}>
                        <span style={{padding: '0.5rem', height: 45, color: '#bcbcbc', fontSize: 14}}>
                            <Popover
                                color='black'
                                placement='bottom'
                                overlayStyle={{maxWidth: 500}}
                                title={
                                    <div style={{color: 'white'}}>
                                        Buscador
                                    </div>
                                }
                                content={
                                    <div style={{color: 'white'}}>
                                        <p>
                                            El buscador permite buscar a través de los siguientes códigos:
                                            <ul>
                                                <li>ISIN</li>
                                                <li>DGS</li>
                                                <li>EPSV</li>
                                            </ul>
                                        </p>
                                    </div>}
                                >
                                {' '}
                                <img className="icon" src={iconInformation} alt='icono informacion' />
                            </Popover>
                        </span>
                    </div>
                    {/* Opciones selects */}
                    <div style={{marginTop: 30}}>
                        <div className='row' style={{justifyContent: 'space-between'}}>
                            <div className='col-lg-3 col-md-6 col-sm-12'>
                                {
                                    queryFilters.tipo &&
                                    <label style={{fontSize: 12, marginLeft: 18, position: 'absolute', zIndex: 2}}></label>
                                }
                                <Select
                                    className={`search-selects searchBoxSelectOptions ${queryFilters.tipo ? 'filled' : ''}`}
                                    options={fondosInversion}
                                    suffixIcon={<SelectArrow />}
                                    placeholder="Productos"
                                    value={queryFilters.tipo}
                                    onSelect={(e) => {searchParamsDispatch({ queryFilters: { ...queryFilters, tipo: e }}); anadirFiltro({ tipo: e });}}                                      
                                    bordered={false}
                                    allowClear
                                    onClear={() => {searchParamsDispatch({queryFilters: {...queryFilters, tipo: null}}); eliminarFiltro({tipo: ""});}}
                                />
                            </div>  
                            <div className='col-lg-3 col-md-6 col-sm-12'>
                                {
                                    queryFilters.descri_categoria &&
                                    <label style={{fontSize: 12, marginLeft: 18, position: 'absolute', zIndex: 2}}>Categoría</label>
                                }
                                <Select
                                    className={`search-selects searchBoxSelectOptions ${queryFilters.descri_categoria ? 'filled' : ''}`}
                                    options={categorías}
                                    suffixIcon={<SelectArrow />}
                                    placeholder="Categoría"
                                    value={queryFilters.descri_categoria}
                                    onSelect={(e) => (searchParamsDispatch({queryFilters: {...queryFilters, descri_categoria: e}}))}
                                    bordered={false}
                                    allowClear
                                    onClear={(e) => (searchParamsDispatch({queryFilters: {...queryFilters, descri_categoria: null}}))}
                                />
                            </div>
                            <div className='col-lg-3 col-md-6 col-sm-12'>
                                {
                                    queryFilters.riesgo &&
                                    <label style={{fontSize: 12, marginLeft: 18, position: 'absolute', zIndex: 2}}>Nivel de riesgo</label>
                                }
                                <Select
                                    className={`search-selects searchBoxSelectOptions ${queryFilters.riesgo ? 'filled' : ''}`}
                                    options={nivelRiesgo}
                                    suffixIcon={<SelectArrow />}
                                    placeholder="Nivel de riesgo"
                                    value={queryFilters.riesgo}
                                    onSelect={(e) => (searchParamsDispatch({queryFilters: {...queryFilters, riesgo: e}}))}
                                    bordered={false}
                                    allowClear
                                    onClear={(e) => (searchParamsDispatch({queryFilters: {...queryFilters, riesgo: null}}))}
                                />
                            </div>
                            <div className='col-lg-3 col-md-6 col-sm-12'>
                                {
                                    queryFilters.geografia &&
                                    <label style={{fontSize: 12, marginLeft: 18, position: 'absolute', zIndex: 2}}>Geografía</label>
                                }
                                <Select
                                    className={`search-selects searchBoxSelectOptions ${queryFilters.geografia ? 'filled' : ''}`}
                                    options={geografías}
                                        suffixIcon={<SelectArrow />}
                                    placeholder="Geografía"
                                    value={queryFilters.geografia}
                                    onSelect={(e) => (searchParamsDispatch({queryFilters: {...queryFilters, geografia: e}}))}
                                    bordered={false}
                                    allowClear
                                    onClear={(e) => (searchParamsDispatch({queryFilters: {...queryFilters, geografia: null}}))}
                                />
                            </div>
                        </div>
                        {
                            showMoreFilters &&
                            <div className='row' style={{marginTop: 30}}>
                                <div className='col-lg-3 col-md-6 col-sm-12'>
                                    {
                                        queryFilters.horizonte &&
                                        <label style={{fontSize: 12, marginLeft: 18, position: 'absolute', zIndex: 2}}>Horizonte de inversión</label>
                                    }
                                    <Select
                                        className={`search-selects searchBoxSelectOptions ${queryFilters.horizonte ? 'filled' : ''}`}
                                        options={horizontes}
                                        suffixIcon={<SelectArrow />}
                                        placeholder="Horizonte de inversión"
                                        value={queryFilters.horizonte}
                                        onSelect={(e) => (searchParamsDispatch({queryFilters: {...queryFilters, horizonte: e}}))}
                                        bordered={false}
                                        allowClear
                                        onClear={(e) => (searchParamsDispatch({queryFilters: {...queryFilters, horizonte: null}}))}
                                    />
                                </div>
                                <div className='col-lg-3 col-md-6 col-sm-12'>
                                    {
                                        queryFilters.inversionMinima &&
                                        <label style={{fontSize: 12, marginLeft: 18, position: 'absolute', zIndex: 2}}>Inversión mínima</label>
                                    }
                                    <Select
                                        className={`search-selects searchBoxSelectOptions ${queryFilters.inversionMinima ? 'filled' : ''}`}
                                        options={inversionMinima}
                                        suffixIcon={<SelectArrow />}
                                        placeholder="Inversión mínima"
                                        value={queryFilters.inversionMinima}
                                        onSelect={(e) => (searchParamsDispatch({queryFilters: {...queryFilters, inversionMinima: e}}))}
                                        bordered={false}
                                        allowClear
                                        onClear={(e) => (searchParamsDispatch({queryFilters: {...queryFilters, inversionMinima: null}}))}
                                    />
                                </div>
                                <div className='col-lg-3 col-md-6 col-sm-12'>
                                    {
                                        queryFilters.divisa &&
                                        <label style={{fontSize: 12, marginLeft: 18, position: 'absolute', zIndex: 2}}>Divisa</label>
                                    }
                                    <Select
                                        className={`search-selects searchBoxSelectOptions ${queryFilters.divisa ? 'filled' : ''}`}
                                        options={divisas}
                                        suffixIcon={<SelectArrow />}
                                        placeholder="Divisa"
                                        value={queryFilters.divisa}
                                        onSelect={(e) => (searchParamsDispatch({queryFilters: {...queryFilters, divisa: e}}))}
                                        bordered={false}
                                        allowClear
                                        onClear={(e) => (searchParamsDispatch({queryFilters: {...queryFilters, divisa: null}}))}
                                    />
                                </div>
                            </div>
                        }
                    </div>
                    <div
                        onClick={() => { setShowMoreFilters(!showMoreFilters); clickEventoMas(showMoreFilters);}}   
                        style={{textAlign: 'end', marginTop: 20, color: 'red', fontWeight: 500, fontSize: 15, cursor: 'pointer'}}>
                            {
                                /*
                            <i
                                style={{border: '1px solid #bcbcbc', borderRadius: 50, width: 25, height: 25, textAlign: 'center', paddingTop: 5}}
                                className="fa-light fa-plus">
                            </i>
                                */
                            }
                            Mostrar {showMoreFilters ? 'menos' : 'más'} filtros
                    </div>
                </form>
                {loading && (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: 'rgba(0, 0, 0, 0.2)', position: 'fixed', top: 0, left: 0, width: '100%', zIndex: 9999 }}>
                        <Spinner animation="border" variant="danger" role="status" /> 
                        <p style={{ marginLeft: '8px', marginTop: '14px' }}>Cargando...</p>
                    </div>
                )}
            </div>
        </section>
    );
};

export default SearchBox;
